exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article-feedback-container {\n  text-align: center; }\n  .article-feedback-container .button-container > button {\n    margin: 20px;\n    padding: 5px 20px;\n    box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2); }\n", ""]);

// exports
